import { Box, Grid, Paper } from "@mui/material";

const Bone = ({ width = "100%", height, circle = false, className = "" }) => (
  <Box
    className={`edsimsV2-skeleton-bone${circle ? " edsimsV2-skeleton-bone--circle" : ""} ${className}`.trim()}
    style={{ width, height }}
    aria-hidden="true"
  />
);

const TileHeader = () => (
  <Box className="edsimsV2-cohort-dashboard-header">
    <Bone width="42%" height={16} />
    <Bone width="88%" height={10} />
    <Bone width="64%" height={10} />
  </Box>
);

const ProgressColumn = () => (
  <Box className="edsimsV2-skeleton-progress-col">
    <Bone width="40%" height={10} />
    {[0, 1, 2].map((row) => (
      <Box key={row} className="edsimsV2-skeleton-progress-row">
        <Bone width="72%" height={10} />
        <Bone height={6} />
      </Box>
    ))}
  </Box>
);

const DashboardSkeleton = () => (
  <Grid
    container
    spacing="16px"
    className="edsimsV2-dashboard-skeleton"
    aria-busy="true"
    aria-live="polite"
  >
    <span className="edsimsV2-sr-only">Loading dashboard</span>

    <Grid size={12}>
      <Paper className="edsimsV2-sim-library-card" elevation={0}>
        <Box className="edsimsV2-skeleton-sim-header">
          <Box className="edsimsV2-sim-library-header">
            <Bone width="180px" height={16} />
            <Bone width="140px" height={10} />
          </Box>
          <Box className="edsimsV2-skeleton-pills">
            <Bone width={110} height={32} />
            <Bone width={110} height={32} />
          </Box>
        </Box>
        <Grid container columnSpacing="32px" rowSpacing="20px">
          <Grid size={{ xs: 12, md: 6 }}>
            <ProgressColumn />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <ProgressColumn />
          </Grid>
        </Grid>
        <Bone width="200px" height={12} />
      </Paper>
    </Grid>

    <Grid size={12}>
      <Paper className="edsimsV2-sim-library-card" elevation={0}>
        <Bone width="280px" height={16} />
        <Bone width="100%" height={10} />
        <Bone width="92%" height={10} />
        <Bone width="78%" height={10} />
      </Paper>
    </Grid>

    <Grid size={{ xs: 12, md: 4 }}>
      <Paper className="edsimsV2-cohort-dashboard-card" elevation={0}>
        <TileHeader />
        <Box className="edsimsV2-skeleton-stack">
          {[0, 1, 2, 3].map((row) => (
            <Bone key={row} height={14} />
          ))}
        </Box>
      </Paper>
    </Grid>

    <Grid size={{ xs: 12, md: 4 }}>
      <Paper className="edsimsV2-cohort-dashboard-card" elevation={0}>
        <TileHeader />
        <Box className="edsimsV2-skeleton-research">
          {[0, 1, 2].map((row) => (
            <Box key={row} className="edsimsV2-skeleton-research-item">
              <Bone circle width={36} height={36} />
              <Bone width="70%" height={12} />
            </Box>
          ))}
        </Box>
      </Paper>
    </Grid>

    <Grid size={{ xs: 12, md: 4 }}>
      <Paper className="edsimsV2-cohort-dashboard-card" elevation={0}>
        <TileHeader />
        <Box className="edsimsV2-skeleton-stack">
          {[0, 1, 2, 3].map((row) => (
            <Box key={row} className="edsimsV2-skeleton-report-row">
              <Box className="edsimsV2-skeleton-report-row-main">
                <Bone circle width={32} height={32} />
                <Bone width="62%" height={12} />
              </Box>
              <Bone circle width={8} height={8} />
            </Box>
          ))}
        </Box>
      </Paper>
    </Grid>
  </Grid>
);

export default DashboardSkeleton;
